import React, { ReactNode } from 'react';
import './style.scss';

export enum FormType {
  Optional,
  Required,
}

type ContentHeaderProps = {
  label: string | ReactNode;
  formType?: FormType;
  conditional?: boolean;
};

export const FormContentHeader = (props: ContentHeaderProps) => {
  const { label, formType, conditional } = props;
  return (
    <>
      <div className={`contentHeader ${conditional ? 'contentHeader_conditional' : ''}`}>
        {formType === FormType.Optional && <div className="contentHeader_optional">任意</div>}
        {formType === FormType.Required && <div className="contentHeader_required">必須</div>}
        {label}
      </div>
    </>
  );
};
